import { Fragment, ReactNode } from "react"
import { AwardStatusOption } from "../../../types.graphql"
import { Button, Chip } from "@components/controls/Button"
import { getDefaultAwardStatusText } from "../utils/awards-utils"
import { useAuth, useIsLoggedIn } from "@features/accounts/hooks/useAuth"
import { IconAdd, IconCaretRight } from "@components/svg/Icons"
import { useAwardForceTransfer } from "@hooks/queries"
import { displayAlert } from "@hooks/useAlertOverlay"

type Props = {
  year: number
  status: AwardStatusOption
  statusTitle: ReactNode
  subtitle?: ReactNode
  editing?: boolean
  isAccountPage?: boolean
  isLandingPage?: boolean
}

export function AwardStatus(props: Props) {
  const buttons: ReactNode[] = []
  const loggedIn = useIsLoggedIn()

  const awardForceTransfer = useAwardForceTransfer()

  if (props.status === "closed") {
    buttons.push(
      <Button key="explore" rightIcon={<IconCaretRight />} variant="outline" href={`/awards/results/`} className="w-full md:w-auto">
        Explore Past Awards
      </Button>,
    )
  }
  if (props.status === "comingSoon" || props.status === "open") {
    buttons.push(
      <Button key="info" rightIcon={<IconCaretRight />} variant="outline" href={`/awards/info/`} className="w-full md:w-auto">
        Awards Info
      </Button>,
    )
  }
  if (props.status === "open") {
    if (props.isAccountPage && loggedIn) {
      buttons.push(
        <Button
          key="submit"
          rightIcon={<IconCaretRight />}
          variant="charcoal"
          className="w-full md:w-auto"
          loading={awardForceTransfer.isPending}
          onClick={() => {
            awardForceTransfer.mutateAsync(
              { input: {} },
              {
                onSuccess(data) {
                  const url = data.awardForceTransfer?.token!
                  window.location.href = url
                },
                onError() {
                  displayAlert({
                    title: "An error occurred",
                    message: "Something went wrong while trying to transfer you to the submmissions portal. Please try again.",
                  })
                },
              },
            )
          }}
        >
          Entries Portal
        </Button>,
      )
    } else {
      // buttons.push(
      //   <Button key="submit" rightIcon={<IconAdd />} variant="charcoal" href={loggedIn ? "/account/awards" : "/awards/info/submit/"} className="w-full md:w-auto">
      //     Submit
      //   </Button>
      // )
    }
  }
  if (props.status === "finalists" || props.status === "winners") {
    buttons.push(
      <Button key="explore" variant="outline" href={`/awards/results/`} className="w-full md:w-auto">
        {props.status === "finalists" ? "Explore Finalists" : "Explore the results"}
      </Button>,
    )
  }

  return (
    <div className="flex flex-col text-center">
      <div className="type-title-s-medium mb-3">AGDA Awards {props.year}</div>
      {props.editing && env.admin && (
        <div className="mb-3">
          <Chip>{getDefaultAwardStatusText(props.status) ?? "No Status Selected"}</Chip>
        </div>
      )}
      <div className="stack-y-1">
        <div className="type-title-xl-medium">{props.statusTitle || getDefaultAwardStatusText(props.status!)}</div>
        {props.subtitle && <div className="type-title-xl-roman">{props.subtitle}</div>}
      </div>
      {!!buttons.length && (
        <div className="mt-6 flex flex-wrap gap-2 items-center justify-center">
          {buttons.map((button, i) => (
            <Fragment key={i}>{button}</Fragment>
          ))}
        </div>
      )}
    </div>
  )
}
